<template>
  <div v-if="showingMappedValues && activeMappedItem && activeMappedItem.values">
    <v-subheader>Valores mapeados a {{activeMappedItem.mapped}}</v-subheader>
    <v-item-tile v-for="(item, index) in activeMappedItem.values" :key="index" :item="item" removable />
    <v-divider />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VItemTile from "./ItemTile";

export default {
  components: {
    VItemTile
  },
  computed: {
    ...mapState("valueMapping", ["activeMappedItem", "showingMappedValues"])
  }
};
</script>